import * as propTypes from 'prop-types';

const StarRating = ({ rating }) => {
  if (!rating) return <div></div>;

  const maxStars = 5;
  const filledStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;

  const starIcons = [];

  // Add filled stars
  for (let i = 0; i < filledStars; i++) {
    starIcons.push(<i key={i} className="fa-solid fa-star text-warning "></i>);
  }

  // Add half star if needed
  if (hasHalfStar) {
    starIcons.push(
      <i key="half" className="fa-solid fa-star-half-alt text-warning "></i>
    );
  }

  // Add empty stars to fill the remaining space
  const remainingStars = maxStars - starIcons.length;
  for (let i = 0; i < remainingStars; i++) {
    starIcons.push(
      <i
        key={i + filledStars}
        className="far fa-star text-warning font-size-xs"
      ></i>
    );
  }

  return <div>{starIcons}</div>;
};

StarRating.propTypes = {
  rating: propTypes.any.isRequired || null
};

export default StarRating;
